interface WorkspaceProject {
  projectType: string
  name: string
  parentProjectIdentifier: string | null
}

export const isMyDrafts = (project: WorkspaceProject) =>
  project.projectType === 'PERSONAL_DRAFTS' &&
  project.name === 'My Drafts' &&
  project.parentProjectIdentifier === null
